<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="price">
        <div class="price-left">
          <img class="price_picture" src="../assets/images/price_picture.png" />
          
          
        
          <p class="companyname" v-html="tips.replace(/\n/g,'<br/>')" v-if="tips">
            
          </p>
          <p  class="nonotice" v-else>
             暂无提示
          </p>
          <el-button class="servicebutton" @click.native="askcustomer()"><img class="service" src="../assets/images/service.png" />咨询客服</el-button>
        </div>
        <div class="price-right">
          <div class="price-right-top" @change="selectcard">
            <el-radio-group v-model="radio1" style="margin-bottom: 30px;">
              <el-radio-button label="拖车询价"></el-radio-button>
              <el-radio-button label="报关询价"></el-radio-button>
            </el-radio-group>
            <div class="line"></div>
          </div>

          <div class="select">
            <div class="selectcontent">
              <span class="label">大区</span>
              <el-select v-model="askRegionId1" class="choice" @change="changeaskRegionId">
                <el-option v-for="item in regionList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="selectcontent">
              <span class="label">港区</span>
              <el-select v-model="port" class="choice" :disabled="!(askRegionId)">
                <el-option v-for="item in portList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="selectcontent">
              <span class="label">还提箱点</span>
              <el-select v-model="back" class="choice" :disabled="!(askRegionId)">
                <el-option v-for="item in boxList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="selectcontent">
              <span class="label">装卸门点</span>
              <el-cascader
    v-model="pack"
    :options="sijiList"
    @change="handleChange" :props="optionProps"></el-cascader>
              <!-- <el-select v-model="pack" class="choice" >
                <el-option :value="packpart" class="setstyle" disabled>
                </el-option>
              </el-select> -->
            </div>
          </div>
          <div class="select_choice">
            <div class="selectcontent">
              <span class="label">大区</span>
              <el-select v-model="askRegionId2" class="choice" @change="changeaskRegionId_report">
                <el-option v-for="item in regionList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="selectcontent">
              <span class="label">品类</span>
              <el-select v-model="type" class="choice" @change="changeskuId">
                <el-option v-for="item in skuList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="price-right-content">
            <div class="askprice">
          
              <div class="reportprice" v-if="selectid"><span class="red"><span class="rednum">{{price ? price : 0}}</span>元/单</span></div>   
            </div>
            <div>

              <el-button class="find" round @click="search()">查询</el-button> <el-upload v-if="selectid" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile" :on-success="updatepicture" multiple :limit="6" accept=".zip,.doc,.docx,.xlsx,.xls,.txt,.ppt,.pptx,.pdf"  :on-remove="handleRemove" :file-list="files" :class="{ hide: hideUpload }" :on-change="ChangeImage"
 > 
                <i class="el-icon-plus" slot="default"></i>
              </el-upload>
            </div>
            <span class="care" v-if="!selectid">温馨提示：有搜索不到的特殊门点区域可咨询业务经理</span>
            <div>
             <div class="table"  v-if="!selectid">
				<div class="ths">
					<div class="th">类型</div>
					<div class="th">数量</div>
					<div class="th">运输服务费单</div>
				</div>  
		      <div></div>
					<div class="tbs" v-for="item in datas" :key="item.id" v-if="datas.length">
						<div class="tb" id="tb1">{{item.carTypeName}}</div>
						<div class="tb" id="tb2">1</div>
						<div class="tb" id="tb3"><div class="p">{{item.price}}</div>元</div>
					</div>
		
				
					<div class="tbs" v-if="!datas.length">
						<div class="tb">#</div>
						<div class="tb" id="tb22">1</div>
						<div class="tb" id="tb33"><div class="p">0</div>元</div>
					</div>
			
			</div>
              <!-- <el-table :data="tableData" v-if="!selectid" border :header-cell-style="{
                    'text-align': 'center',
                    'background-color': 'rgb(238,238,238)',
                    color: 'rgb(51,51,51)',
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    border: 'none'
                  }" :cell-style="{
                    'text-align': 'center',
                    color: 'rgb(102,102,102)',
                    'font-size': '14px',
                    'font-family': 'Microsoft YaHei',
                    height: '70px'
                  }">
                <el-table-column prop="carTypeName" label="类型">
                </el-table-column>
                <el-table-column prop="num" label="数量">
                </el-table-column>
                <el-table-column prop="price" label="运输服务费单（元)">
                </el-table-column>
              </el-table> -->

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  customer_report,
  customer_car
} from "../api/api"
import {
  provinceList
} from "../api/api"
import {
  pricecar1
} from "../api/api"
import {
  pricecar2
} from "../api/api"
import {
  price
} from "../api/api"
import {
  ortAreaList
} from "../api/api"
import {
  boxSiteList
} from "../api/api"
import {
  askregionList
} from "../api/api"
import {
  skuList
} from "../api/api"
import transparentheaders from "../components/transparentheaders.vue";
export default {
  name: "caseManagementIndex",
  data() {
    return {
      price: "", //报关询价费用
      multipartFile: {
        biz: "file"
      }, //文件上传参数
      msg: "", //消息提示
       hideUpload: "",
      //文件列表
      selectid: 0, //选择哪一个板块
      radio1: "拖车询价",
      askRegionId1: "", //大区1的值
      askRegionId2: "", //大区2的值
      port: "",
      back: "",
      pack: "",
      type: "",
      regionList: [], //大区列表
      askRegionId: "", //大区id
      boxList: [], //还提箱点列表，
      sijiList: [],//装卸门点列表
      portList: [], //港区列表,
      skuList: [], //品类列表
      skuId: "", //分类编号
      userid: "", //用户编号
      // tableData: [{
      //   carTypeName: "#",
      //   num: 1,
      //   price: "0"
      // },],
      address:"",
      provinceId: "",
      cityId: "",
      districtId: "",
      townshipId:"",
      tips:"",
      datas: [],
      files: [],
      files_up: [],
optionProps: {
  value: 'value',
  label: 'text',
  children: 'children'
},
id:"",


    };
  },
  components: {
    transparentheaders
  },
  mounted() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id
    this.getaskregionList();
    this.getskuList();
    this.getprovinceList();

  },
  methods: {
    handleChange(e) {
				this.provinceId = e[0]
				this.cityId = e[1]
				this.districtId = e[2]
        this.townshipId = e[3]
        if(!this.townshipId) {
          this.townshipId = ""
      }
        if(!this.districtId) {
          this.districtId = ""
        }
      },
    selectcard() {
      var element = document.querySelector(".select");
      var selectelement = document.querySelector(".select_choice");
      if (element.style.display === "none") {
        element.style.display = "block";
        selectelement.style.display = "none";
        this.type = "";
        this.region = "";
        this.selectid = 0
      } else {
        element.style.display = "none";
        this.isSelected = false;
        selectelement.style.display = "block";
        this.selectid = 1
      }
    },
    getaskregionList() {
      askregionList().then(res => {
        if (res.data.code == 200) {
          this.regionList = res.data.result;
          this.getortAreaList();
          this.getboxSiteList();
        }
      });
    },

    getortAreaList() {
      ortAreaList({
        askRegionId: this.askRegionId1
      }).then(res => {
        if (res.data.code == 200) {

          this.portList = res.data.result;
        }
      });
    },
    getboxSiteList() {
      boxSiteList({
        askRegionId: this.askRegionId1
      }).then(res => {
        if (res.data.code == 200) {

          this.boxList = res.data.result;
        }
      });
    },
    getskuList() {
      skuList().then(res => {
        if (res.data.code == 200) {

          console.log(res.data.result);
          this.skuList = res.data.result;
          for (let i = 0; i < res.data.result.length; i++)
            this.skuId = res.data.result[i].skuId;
        }
      });
    },
    changeaskRegionId(e) {
      this.askRegionId = e;
      this.getortAreaList();
      this.getboxSiteList();
      this.port = "";
      this.back = "";
    },
    changeaskRegionId_report(e) {
      this.askRegionId = e;
    },
    changeskuId(e) {
      this.skuId = e;
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {

      });
    },
    getprice() {
      price({
        annex1: this.files_up[0] ? this.files_up[0] : '',
        annex2: this.files_up[1] ? this.files_up[1] : '',
        annex3: this.files_up[2] ? this.files_up[2] : '',
        annex4: this.files_up[3] ? this.files_up[3] : '',
        annex5: this.files_up[4] ? this.files_up[4] : '',
        annex6: this.files_up[5] ? this.files_up[5] : '',
        appuserId: this.userid,
        askRegionId: this.askRegionId2,
        skuId: this.skuId,
      }).then(res => {
        if (res.data.code == 200) {
          if(res.data.result.length) {
  this.price = res.data.result[0].price
          this.tips = res.data.result[0].operationTips
          }
        else {
          this.price = ""
          this.tips = ""
          this.msg = "您所查询的区域暂无报价，如有需要请联系平台客服"
          this.open();
        }
        }
      });
    },
    getprice_car() {
      pricecar1({
        appuserId: this.userid,
        bigRegionId: this.askRegionId1,
        portAreaId: this.port,
        boxSiteId: this.back,
        provinceId: this.provinceId,
        cityId: this.cityId,
        districtId: this.districtId,
         townshipId: this.townshipId
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.result.length) {
            this.datas = res.data.result
          }
          else {
            this.datas = ""
             this.msg = "您所查询的区域暂无报价，如有需要请联系平台客服"
          this.open();
          }
               
          
        }
      });
      pricecar2({
        askRegionId: this.askRegionId1,
        position: 0,
        portAreaId: this.port,
        boxSiteId: this.back,
        proviceId: this.provinceId,
        cityId: this.cityId,
         districtId: this.districtId,
         townshipId: this.townshipId
      }).then(res => {
        if (res.data.code == 200) {
              this.tips = res.data.result.operationTips
        }
         
      });
    },
    action(data){ // 使用递归函数
			    // if(!(data?.length <= 0)){ 
			    // 等价于
				if(!data || data.length <= 0){ // 递归的出口
					return null;
				}
				return data.map(x => { // 循环数据
				    const model = { // 把后端返回过来的数据里面的键给替换成我想要的键
						source: x,
						text: x.value,
						value: x.key,
					};
				    const children = this.action(x.children); // 子级数据
							
							// console.log(children)			
				    if(children){ // 一直往下循环查找有没有children这个键，如果有就直接添加一个子级字段名，这个字段名就是存子级数据

						children.forEach(e => {
							if(!e.source.children) {
								children.unshift({
									text: "暂不选择",
									value: "",
								})
							}
						})
model.children = children;
}
					
					return model; // 返回这个数据
				});
			},
    getprovinceList() {
      provinceList().then(res => {
        if (res.data.code == 200) {
          this.sijiList = this.action(res.data.result)
          console.log(this.sijiList)
        }
      });
    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        // if (this.msg === "注册成功") {
        //   this.$router.push({
        //     path: "/"
        //   });
        // }
      });
    },
    search() {
      if (this.selectid) {
        if (!this.type) {
          this.msg = "请先选择品类"
          this.open();
        }
        if (!this.askRegionId2) {
          this.msg = "请先选择大区"
          this.open();
        }
        if (this.type && this.askRegionId2) {
          this.getprice();

        }
      } else {
        if (!this.back) {
          this.msg = "请先选择还提箱点"
          this.open();
        }
        if (!this.port) {
          this.msg = "请先选择港区"
          this.open();
        }
        if (!this.askRegionId1) {
          this.msg = "请先选择大区"
          this.open();
        }
        if (this.back && this.askRegionId1 && this.port) {
          this.getprice_car();

        }
      }

    },
    updatepicture(res) {
      
      this.files_up.push(res.message)
      this.files = this.files_up.map(item => {
        return {
          name: item,
          url: item
        }
      });
      // if (!this.annex1) {
      //   this.annex1 = res.message
      //   return
      // }
      // if (!this.annex2) {
      //   this.annex2 = res.message
      //   return
      // }
      // if (!this.annex3) {
      //   this.annex3 = res.message
      //   return
      // }
      // if (!this.annex4) {
      //   this.annex4 = res.message
      //   return
      // }
      // if (!this.annex5) {
      //   this.annex5 = res.message
      //   return
      // }
      // if (!this.annex6) {
      //   this.annex6 = res.message
      //   return
      // }
    },
    askcustomer() {
      if (this.selectid) {
        if (!this.type) {
          this.msg = "请先选择品类"
          this.open();
        }
        if (!this.askRegionId2) {
          this.msg = "请先选择大区"
          this.open();
        }
        if (this.type && this.askRegionId2) {
          price({
        appuserId: this.userid,
        askRegionId: this.askRegionId2,
        skuId: this.skuId,
      }).then(res => {
        if (res.data.code == 200) {
          console.log(res.data.result.length)
          if (!res.data.result.length) {
                this.msg = "暂未匹配客服"
                this.open();
              }
              else {
                this.id = res.data.result[0].appuserId
                console.log(this.id)
                this.$router.push({path:'/kefu',query: {id:this.id}})
              }
        }
      });

        }

      } else {
        if (!this.pack) {
          this.msg = "请先选择装卸门点"
          this.open();
        }
        if (!this.port) {
          this.msg = "请先选择港区"
          this.open();
        }
        if (!this.askRegionId1) {
          this.msg = "请先选择大区"
          this.open();
        }
        if (this.pack && this.askRegionId1 && this.port) {
          pricecar2({
            askRegionId: this.askRegionId1,
        position: 0,
        portAreaId: this.port,
        boxSiteId: this.back,
        proviceId: this.provinceId,
        cityId: this.cityId,
         districtId: this.districtId,
         townshipId: this.townshipId
          }).then(res => {
            console.log("1111")
            if (!res.data.result) {
                 
                this.msg = "暂未匹配客服"
                this.open();
              }
            if (res.data.code == 200) {
              
              
                this.id = res.data.result.appuserId
                console.log(this.id)
                this.$router.push({path:'/kefu',query: {id:this.id}})
             
            }
          });

        }
      }

    },
   handleRemove(file, fileList) {
       const index = this.files.findIndex((item) => {
        return item.uid === file.uid
      })
      this.files.splice(index, 1)
      this.files_up.splice(index, 1)
     this.hideUpload = false
      },
       ChangeImage(file, fileList) {
       
         this.hideUpload =  fileList.length > 5;
         
    
    },
  }

};
</script>

<style lang="scss" scoped>
.price {
  margin-top: 70px;
  display: flex;
  height: 90vh;
}

.price-left {
  background: white;
  flex-grow: 0.23;
  margin-right: 10px;
  font-size: 26px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  line-height: 4.5;
  flex-shrink: 0;
  padding: 20px;
  flex: 0 0 300px;
  text-align: center;
  // height: 1080px;
}

.price-left div {
  font-size: 14px;
  font-family: "SourceHanSansCN";
  color: rgb(85, 85, 85);
  line-height: 5.143;
}

.price_picture {
  margin-top: 27px;
  width: 258px;
  height: 144px;
}

.price-right {
  background: white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 10px;
  // height: 1080px;
}

.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  height: 100vh;
}

.white {
  background: white;
}

p {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(119, 119, 119);
  line-height: 2;
  text-align: left;
  margin-left: 22px;
  margin-right: 15px;
  margin-top: 27px;
}

.companyname {
  margin-top: 40px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
  line-height: 2;
  text-align: justifyLeft;
}

.el-button {
  background-color: rgb(255, 152, 31);
  text-align: center;
  border-radius: 20px;
  width: 183px;
  height: 42px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
}

.service {
  margin-right: 8px;
  margin-bottom: 6px;
  margin-top: 2px;
}

.servicebutton {
  margin-right: 5px;
  padding: 8px;
}

.care {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(163, 163, 163);
  line-height: 1.714;
  text-align: justifyLeft;
}

.find {
  width: 237px;
  height: 44px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
  line-height: 1.5;
  letter-spacing: 3px;
  background-color: rgb(10, 108, 255);
  text-align: center;
  margin-top: 17px;
  padding: 9px;
}

.el-select {
  width: 525px;
  height: 48px;
  margin-bottom: 5px;
}
>>> .el-cascader {
  width: 525px;
  height: 48px;
}
>>>.el-icon-arrow-up:before {
  margin-left: 10px;
  content: url(../assets/images/arrowdown_grey.png);
}
>>> .el-icon-arrow-down:before{
  content: url(../assets/images/arrowup_grey.png);
  margin-right: 8px;
}
span {
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: rgb(102, 102, 102);
  line-height: 1.5;
}

.price-right-content {
  display: flex;
  text-align: center;
  flex-direction: column;
  padding: 20px;
}

.select {
  display: flex;
  flex-direction: column;
}

.select_choice {
  display: none;
  flex-direction: column;
}

.price-right-content {
  display: flex;
  flex-direction: column;
}

.el-table {
  margin-top: 44px;
  margin-left: 30px;
  margin-bottom: 88px;
  background: none;
  border-radius: 8px;
}

.price-right-top {
  margin-left: 30px;
  margin-top: 35px;
  margin-bottom: 50px;
}

.selectcontent {
  display: flex;
  justify-content: flex-end;
  margin-right: 200px;
}

.label {
  text-align: right;
  margin-top: 5px;
  margin-right: 10px;
}

.care {
  margin-top: 22px;
}

.el-radio-button {
  margin-left: -3px;
}

>>>.el-table {
  width: 820px;

  .el-table__header-wrapper table,
  .el-table__body-wrapper table {
    width: 100% !important;
  }

  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto;
  }
}

>>>.el-radio-button__inner {
  width: 128px;
  height: 40px;
  margin-right: 5px;
  background: rgb(234, 234, 234);
  font-size: 16px;
  font-family: "Microsoft YaHei";
  color: rgb(51, 51, 51);
}

// >>> .el-radio-button__inner:hover {
//  background-color: rgb(10, 108, 255);

// }
>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  // 修改按钮激活样式
  background-color: rgb(10, 108, 255);
}

.line {
  border: 0.01px solid rgb(221, 221, 221);
  margin-top: -29px;
  width: 850px;
}

.askprice {
  display: flex;
  justify-content: space-around
}

.reportprice {
  display: flex;
  align-items: center;
 
}

.red {
  color: #ec1818;
  padding-left: 5px;
}

.rednum {
  color: #ec1818;
  font-size: 22px;
  padding-right: 5px;
}



>>>.el-upload--picture-card {
  height: 80px;
  width: 80px;
  line-height: 86px;
}

>>>.el-input__inner {
  border-radius: 10px;
}
.table {
		margin: 30px 0;
		padding: 10px 28px;
		border-radius: 10px;
	
		font-size: 16px;
		color: #333333;
		background-color: #ffffff;
		.ths {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			padding: 10px 40px;
			border-bottom: 1px solid #e7eaec;
			.th {
				flex: 1;
				
			}
		}
  }
  .tbs {
			display: flex;
			align-items: center;
			justify-content: space-between;
      padding-left: 160px;
			.tb {
				flex: 1;
				display: flex;
				align-items: center;
				line-height: 2;
				.p {
					color: #ec1818;
				}
			}
		}
#tb2 {
  margin-left: 70px;
}
#tb1 {
  margin-left: -40px;
}
#tb22 {
  margin-left: 30px;
}
.nonotice {
  text-align: center;
  font-size: 18px;
  color: #333333;
}
.el-icon-plus {
    font-size: 28px;
    color: #8c939d;
    width: 78px;
    height: 78px;
    line-height: 78px;
     margin-top: 25px;
     border: 1px dashed #d9d9d9;
    border-radius: 6px;
    margin-right: 450px;
  }
    
>>>.el-upload-list  {
     width: 300px;
    margin-top: -80px;
    margin-left: 270px;
} 
>>>.el-button.is-round {
  padding: 0px;
}
>>>.el-upload-list__item.is-ready {
  display: none;
}

>>>.el-upload-list__item {
  transition: none !important;
}
>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}
</style>
<style>
.hide .el-icon-plus {
 visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/price.vue